// extracted by mini-css-extract-plugin
export default {"layout":"Toast_layout__KRElf","titleBox":"Toast_titleBox__EGXXc","text":"Toast_text__q1Tow"};